import { IAutomationObject } from '../../../types'

export interface IAHU_Optimizer extends IAutomationObject {
    enable: boolean;
    isDisabled: boolean;
    outMin: number;
    outMax: number;
    output: number;
    internalOutput: number;
    setpointHeat: number;
    setpointCool: number;
    setpointAQ: number;
    actTemp: number;
    actAQ: number;
    onValueChanged: any;
}


export const schema = 'AutomationApps.Plants.Optimizations.AHU_Optimizer';

